// @flow

const endpoints = {
  downloadGuaranteeRequestPdf: (financingProcessId: string) =>
    `/financing_processes/${financingProcessId}/guarantee_responses/products/guarantee_request_pdf`
};

export default endpoints;
